<template>
  <div>
    <div class="projects-list">
      <div
        class="project-box project-hover"
        style="cursor: pointer"
        v-for="current in dataTabla.results"
        v-bind:key="current.id"
        @click="rowClick(current)"
      >
        <div class="project-head">
          <div class="project-title">
            <h6>
              # {{ current.numero }}
              <div v-if="current.estado == 'A'" class="badge badge-success">
                Abierto
              </div>
              <div v-if="current.estado == 'C'" class="badge badge-dark">
                Finalizado
              </div>
              <div v-if="current.estado == '9'" class="badge badge-danger">
                Anulado
              </div>
            </h6>
            <span class="font-weight-bold">{{
              current.tienda_obj.nombre
            }}</span>
            <br />
            <span class="font-weight-bold">
              {{ current.proveedor_obj.codigo }}
              {{ current.proveedor_obj.nombre }}</span
            >
          </div>
          <hr />
          <div class="align-items-center">
            <div class="row">
              <div class="el-tablo highlight text-center col-6">
                <div class="label">Fecha</div>
                <div>
                  <strong
                    ><p class="text-center" style="color: #3ab41d">
                      {{ current.fecha_creacion | moment("DD/MM/YYYY") }}
                    </p></strong
                  >
                </div>
              </div>
              <div class="el-tablo highlight text-center col-6">
                <div class="label">Usuario</div>
                <div>
                  <strong
                    ><p class="text-center" style="color: #3ab41d">
                      {{ current.usuario_obj.username }}
                    </p></strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  props: {
    dataTabla: {
      type: Object,
      required: this,
    },
  },
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-recepcion_devolucion-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-recepcion_devolucion-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
